import { TemplatesResult } from '@/service'
import { Flex } from '@/components/ui'
import styled from 'styled-components'

interface PercentageProps {
  template: TemplatesResult
}

export function Percentage({ template }: PercentageProps): JSX.Element {
  const questionCount = template.Questions || 1

  const timeToComplete = Math.round(
    1.2 * (Math.log(questionCount) / Math.log(2))
  )
  const timeSaving = 20 * Math.round(Math.log(questionCount) / Math.log(2))
  const unit = !isNaN(timeToComplete) && timeToComplete > 1 ? 'mins' : 'min'

  return (
    <Container className="py-12">
      <Statistic justify="space-between">
        <StatisticItem className="text-center">
          <h3 className="text-5xl font-bold text-slate-900">{questionCount}</h3>
          <p className="text-slate-500">Questions</p>
        </StatisticItem>
        <StatisticItem className="text-center">
          <h3 className="text-5xl font-bold text-slate-900">
            {timeSaving}
            <span className="text-xl">%</span>
          </h3>
          <p className="text-slate-500">Time savings</p>
        </StatisticItem>
        <StatisticItem className="text-center">
          <h3 className="text-5xl font-bold text-slate-900">
            {timeToComplete}
            <span className="text-xl">{unit}</span>
          </h3>
          <p className="text-slate-500">To complete</p>
        </StatisticItem>
      </Statistic>
    </Container>
  )
}

const Container = styled.div``

const Statistic = styled(Flex)`
  width: 100%;
  max-width: 1050px;
  margin: 0 auto;
  @media only screen and (max-width: 800px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`

const StatisticItem = styled.div`
  width: 230px;
  @media only screen and (max-width: 800px) {
    margin-bottom: 30px;
  }
`
